import { isMobile } from 'is-mobile'

export default function (): boolean {
  return isMobile()
}
